  // --------------------------------- キット用ポップアップ表示・非表示 ---------------------------------

  window.addEventListener('DOMContentLoaded',function(event) {
    var popup = document.getElementById("js-kit-modal");
    if(!popup) return;
  
    var closeBtn = document.getElementById("modal-close-btn");
  
    closePopUp(closeBtn);

    let kitProducts = document.getElementsByClassName("mb-gift__collection-product-for-kit");
    Array.from(kitProducts).forEach(function(kitProduct) {
      openPopUp(kitProduct);
    });

    function closePopUp(elem) {
      if(!elem) return;
      elem.addEventListener("click", function() {
        popup.classList.toggle("is-show", false);
      })
    }

    function openPopUp(elem) {
      if(!elem) return;
      elem.addEventListener("click", function() {
        popup.classList.toggle("is-show", true);
      })
    }
  });

  // --------------------------------- オリジナル画像アップロード関連 ---------------------------------

  function readURL(input, form) {
    if (input.files && input.files[0]) {
      let reader = new FileReader();
      reader.onload = function(e) {
        let preview = form.querySelector(".previewImage");
        preview.src = e.target.result;
        togglePreview(true, form);
      }
      reader.readAsDataURL(input.files[0]);
    }
  }

  function unsetImage(input, form) {
    input.value = "";
    togglePreview(false, form);
  }

  function togglePreview(uploaded, form) {
    let unuploaedWrapper = form.getElementsByClassName("mb-gift__uploader-image")[0];
    let uploaedWrapper = form.getElementsByClassName("mb-gift__uploader-preview")[0];
    if (uploaded) {
      unuploaedWrapper.style.display = "none";
      uploaedWrapper.style.display = "block";
    } else {
      unuploaedWrapper.style.display = "block";
      uploaedWrapper.style.display = "none";
    }
  }

  document.querySelector("#kitImageUploadInput").addEventListener("change", function() {
    readURL(this, document.getElementById("gift-modal-form"));
  });

  document.querySelector("#kitUnsetUploadImage").addEventListener("click", function() {
    unsetImage(this, document.getElementById("gift-modal-form"));
  });

  const imageUploadInput = document.querySelector("#imageUploadInput");
  if(imageUploadInput){
    imageUploadInput.addEventListener("change", function() {
      readURL(this, document.getElementById("gift-form"));
    });
  }

  const unsetUploadImage = document.querySelector("#unsetUploadImage");
  if(unsetUploadImage){
    unsetUploadImage.addEventListener("click", function() {
      unsetImage(this, document.getElementById("gift-form"));
    });
  }


  // --------------------------------- ADD TO BAG を押したときに色々チェック ---------------------------------
  // kit 以外のは gift-template のほうに記載

  $('#kit-form-submit').on('click', function (e){
    //カラータイプ選択がされているかチェック
    var colorVal = $("#mb-gift-color-types input[name='properties[カラータイプ]']:checked").val();
    if(!colorVal){
      $(".gift_wrap_note_color").slideDown();
      e.preventDefault();
    }else{
      $(".gift_wrap_note_color").hide();
    }
    //ラッピング有りの場合、デザインを選択されているかチェック
    var hasGiftWrap = $("#kit-wrapping-tab-yes").prop("checked");
    var giftVal = $("#mb-kit-wrappings input[name='properties[ラッピング]']:checked").val();
    if(!hasGiftWrap){
      $("#mb-kit-wrappings input[name='properties[ラッピング]']:checked").prop("checked", false);
    }
    if(hasGiftWrap && !giftVal){
      $(".gift_wrap_note_design").slideDown();
      e.preventDefault();
    }else{
      $(".gift_wrap_note_design").hide();
    }
    //Dear, From が空の場合はプレビュー上の Dear, From を非表示にする
    const dearVal = $(`#kitMessageCard [name="messageDear"]`).val();
    $(`[data-preview-name="kitMessageDearPreview"]`).text(dearVal);
    const fromVal = $(`#kitMessageCard [name="messageFrom"]`).val();
    $(`[data-preview-name="kitMessageFromPreview"]`).text(fromVal);
  });

  // --------------------------------- キットフォーム全般いろいろ ---------------------------------

  (function() {

    let tabHandler = new TabHandler();
    tabHandler.setup({
      tabInputClass: "mb-gift__tab-input",
    });
    tabHandler.defaultTabs([
      "kit-wrapping-tab-yes",
      "kit-noshi-tab-no",
      "kit-message-tab-text"
    ]);

    let kitVariantHandler = new VariantHandler({
      form: document.getElementById("gift-modal-form"),
      productIdSelector: "#kit-product-id",
      variantOptionKeySelector: "variant-option-key",
      variantOptionValueSelector: "variant-option-value",
      variantOptions: [
        {
          querySelector: ".gift-options-input[variant-option-key='option1']:checked",
        },
        {
          querySelector: ".gift-options-input[variant-option-key='option2']:checked",
        }
      ],
    });

    function setupKitVariantsUpdater(form) {
      let optionInputs = form.getElementsByClassName("gift-options-input");
      Array.from(optionInputs).forEach(function(optionInput) {
        optionInput.addEventListener("change", function() {
          if (optionInput.checked) {
            kitVariantHandler.update();
          }
        });
      });
    
      let giftNoshiNo = form.querySelector("#kit-noshi-tab-no");
      giftNoshiNo.addEventListener("change", function() {
        if (giftNoshiNo.checked) {
          toggleInputGroupEnabled(form, "[name='properties[あてな]']", false)
          toggleInputGroupEnabled(form, "[name='properties[表書き]']", false)
        }
      });
    
      let giftNoshiYes = form.querySelector("#kit-noshi-tab-yes");
      giftNoshiYes.addEventListener("change", function() {
        if (giftNoshiYes.checked) {
          toggleInputGroupEnabled(form, "[name='properties[あてな]']", true)
          toggleInputGroupEnabled(form, "[name='properties[表書き]']", true)
        }
      });
    
      let giftMessageNo = form.querySelector("#kit-message-tab-none");
      giftMessageNo.addEventListener("change", function() {
        if (giftMessageNo.checked) {
          toggleInputGroupEnabled(form, ".gift-options-input[variant-option-key='option3']", false)
          kitVariantHandler.update();
        }
      });
    
      let giftMessageYes = form.querySelector("#kit-message-tab-text");
      giftMessageYes.addEventListener("change", function() {
        if (giftMessageYes.checked) {
          toggleInputGroupEnabled(form, ".gift-options-input[variant-option-key='option3']", true)
          kitVariantHandler.update();
        }
      });
    }

    setupKitVariantsUpdater(document.getElementById("gift-modal-form"));
    kitVariantHandler.update();

    function toggleInputGroupEnabled(form, selector, enabled) {
      let inputs = form.querySelectorAll(selector)
      Array.from(inputs).forEach(function(input) {
        input.disabled = !enabled;
      });
    }
  })();

